
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"15","viewBox":"0 0 16 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.429 0H.57A.574.574 0 000 .577c0 .318.256.577.571.577h14.286v9.23H7.43c-.024 0-.044.011-.067.014a.508.508 0 00-.218.074c-.019.01-.04.014-.058.028l-3.657 2.77v-2.308a.574.574 0 00-.572-.577H1.143v-7.5a.574.574 0 00-.572-.577.574.574 0 00-.571.577v8.077c0 .319.256.576.571.576h1.715v2.885a.578.578 0 00.571.577.566.566 0 00.343-.115l4.419-3.347h7.81a.574.574 0 00.571-.576V.577A.574.574 0 0015.429 0z","fill":"#C3C3C3","fill-rule":"evenodd"}})])
          )
        }
      }
    